"use memo";

import { useFeatureFlagEnabled } from "posthog-js/react";
import { isProductionEnvironment } from "@remi/environment";

// Outside production PostHog serves an empty flag set, so every flag resolves to an explicit false
// and flag-gated features are untestable in dev/preview without this default.
export function useFeatureFlagWithNonProdDefault(flag: string): boolean | undefined {
  const enabled = useFeatureFlagEnabled(flag);
  return isProductionEnvironment() ? enabled : true;
}
